// entries/admin_extension_tokens/components/StatusBadge.jsx
import { useTranslation } from "react-i18next"

const StatusBadge = ({ count = 0, max = 5 }) => {
  const { t } = useTranslation()

  if (count === 0) {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#F4F6F9] text-[#9AA5B4] text-xs font-medium">
        <span className="w-1.5 h-1.5 rounded-full bg-[#C7CDD6]" />
        {t("admin_extension_tokens.badge.no_token")}
      </span>
    )
  }

  const atLimit = count >= max

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
        atLimit ? "bg-[#FFF4E5] text-[#B45309]" : "bg-[#E9F9EF] text-[#16A34A]"
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${atLimit ? "bg-[#B45309]" : "bg-[#16A34A]"}`} />
      {t("admin_extension_tokens.badge.active_count", { count, max })}
    </span>
  )
}

export default StatusBadge
